import React, { useEffect, useState } from "react";
import api from "api"; // adapte si besoin
import Swal from "sweetalert2";
export default function AdminParameters() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const [params, setParams] = useState({
    userOnFREventsNotification: false,
  });

  // =========================
  // LOAD
  // =========================
  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        setError(null);
        const res = await api.get("/admin/parameters");
        const data = res?.data || {};

        setParams({
          userOnFREventsNotification:
            !!data?.userOnFREventsNotification,
        });
      } catch (e) {
        setError("Erreur lors du chargement des paramètres.");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  // =========================
  // HANDLERS
  // =========================
  const handleChange = (e) => {
    const { name, checked } = e.target;
    setParams((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setSaving(true);

      await api.put("/admin/parameters", params);

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Paramètres enregistrés",
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
      });

    } catch (e) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Erreur lors de l’enregistrement",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="card">
        <div className="card-body">
          <div className="text-muted">Chargement…</div>
        </div>
      </div>
    );
  }

  return (
    <div id="admin-parameters" className="py-4">
      <div class="d-flex justify-content-between align-items-center mb-3"><h1 class="h4 m-0">Paramétrages</h1></div>
      <div className="container">

        <div className="card">
          <div className="card-header">
            Paramètres administrateur
          </div>

          <div className="card-body">
            {error && (
              <div className="alert alert-danger">
                {error}
              </div>
            )}

            {success && (
              <div className="alert alert-success">
                Paramètres enregistrés.
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-check mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="userOnFREventsNotification"
                  name="userOnFREventsNotification"
                  checked={params.userOnFREventsNotification}
                  onChange={handleChange}
                  disabled={saving}
                />
                <label
                  className="form-check-label"
                  htmlFor="userOnFREventsNotification"
                >
                  Me notifier les validations et les paiements des demandes de formalité
                </label>
              </div>

              <button
                type="submit"
                className="btn btn-sm btn-outline-primary rounded-pill "
                disabled={saving}
              >
                {saving ? "Enregistrement…" : "Enregistrer"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}